'use client';
import { NotFoundComponent } from '@dh/components';

export default function NotFound() {
    return <NotFoundComponent />;
}
